import { CompanyAction, CompanyState } from "../context/types";

export const initialCompanyState: CompanyState = {
  companies: [],
  selectedCompany: "",
  companyInfo: null,
  showNewCompanyForm: false,
  isEditable: false,
  loading: false,
  error: null,
};

export const companyReducer = (
  state: CompanyState,
  action: CompanyAction
): CompanyState => {
  switch (action.type) {
    case "SET_COMPANIES":
      return { ...state, companies: action.payload };
    case "SET_SELECTED_COMPANY_NAME":
      return { ...state, selectedCompany: action.payload };
    case "SET_COMPANY_INFO":
      return { ...state, companyInfo: action.payload };
    case "TOGGLE_NEW_COMPANY_FORM":
      return { ...state, showNewCompanyForm: !state.showNewCompanyForm };
    case "TOGGLE_EDIT_MODE":
      return { ...state, isEditable: !state.isEditable };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "ADD_COMPANY":
      return { ...state, companies: [...state.companies, action.payload] };
    case "UPDATE_COMPANY":
      return {
        ...state,
        companies: state.companies.map((company) =>
          company.company_id === action.payload.company_id
            ? action.payload
            : company
        ),
      };
    default:
      return state;
  }
};
